import styled from 'styled-components'
import { IMaskInput } from 'react-imask'

export const InputMask = styled(IMaskInput).attrs(({ className }) => ({
  className: `form-input ${className}`,
  autoComplete: 'none',
  onChange: null,
  unmask: true,
}))``

export const Phone = styled(InputMask).attrs({
  mask: [{ mask: '(00) 0000-0000' }, { mask: '(00) 0 0000-0000' }],
  type: 'tel',
})``

const CNPJ_MASK = {
  mask: 'XX.XXX.XXX/XXXX-00',
  definitions: { X: /[A-Z0-9]/ },
  prepare: (value) => value.toUpperCase(),
}

export const CpfCnpj = styled(InputMask).attrs({
  mask: [{ mask: '000.000.000-00' }, CNPJ_MASK],
  type: 'text',
})``

export const Cpf = styled(InputMask).attrs({
  mask: '000.000.000-00',
  type: 'tel',
})``

export const Cnpj = styled(InputMask).attrs({
  ...CNPJ_MASK,
  type: 'text',
})``

export const Rga = styled(InputMask).attrs({
  mask: '0000.0000.0000.0000.0000',
  type: 'tel',
})``
